var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationDarkblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification_darkblue",
    transform: "translate(16207.001 8789)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7887",
    "data-name": "Rectangle 7887",
    width: 28,
    height: 28,
    transform: "translate(-16207.001 -8789)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M6548.382,13044.794v-4.874a6.922,6.922,0,1,0-13.843,0v4.874a2.692,2.692,0,0,0,1.153,5.124h2a3.845,3.845,0,0,0,7.537,0h2a2.692,2.692,0,0,0,1.153-5.124Zm-6.921,6.662a2.307,2.307,0,0,1-2.166-1.538h4.332A2.306,2.306,0,0,1,6541.46,13051.456Z",
    transform: "translate(-22734.461 -21817.998)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDarkblue);
export default __webpack_public_path__ + "static/media/Notification_darkblue.aa26b8d34c5d914d2d92c2ca43f0ab05.svg";
export { ForwardRef as ReactComponent };